module.exports = __webpack_public_path__ + "static/media/group-logo.cc21cce0.jpg";